<template>
    <a-drawer :title="title" width="500" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-descriptions title="基本资料" bordered :column="1" size="middle">
            <a-descriptions-item label="ID">
                {{ item.id }}
            </a-descriptions-item>
            <a-descriptions-item label="名称">
                {{ item.name }}
            </a-descriptions-item>
            <a-descriptions-item label="角色">{{ item.role | fmtUserRole }} [{{ item.role }}]</a-descriptions-item>
        </a-descriptions>
        <a-divider />
        <a-descriptions title="账号信息" bordered :column="1" size="middle">
            <a-descriptions-item label="是否绑定微信">
                {{ item.wxmp.bind ? '已绑定' : '未绑定' }}
            </a-descriptions-item>
            <a-descriptions-item label="微信绑定码" v-if="!item.wxmp.bind">
                {{ item.wxmp.code || '未设置绑定码或已过期' }}
            </a-descriptions-item>
            <a-descriptions-item label="绑定码过期" v-if="!item.wxmp.bind && item.wxmp.code">
                {{ item.wxmp.time }}
            </a-descriptions-item>
            <a-descriptions-item label="绑定二维码" v-if="!item.wxmp.bind && item.wxmp.code">
                <a-button type="primary" icon="cloud-download" @click="execDownQr">下载二维码</a-button>
            </a-descriptions-item>
            <a-descriptions-item label="最近登录IP">
                {{ item.last.ip || '未登录' }}
            </a-descriptions-item>
            <a-descriptions-item label="最近登录时间">
                {{ item.last.time || '未登录' }}
            </a-descriptions-item>
            <a-descriptions-item label="是否锁定">
                {{ item.lock.flg ? '已锁定' : '未锁定' }}
            </a-descriptions-item>
            <a-descriptions-item label="锁定原因" v-if="item.lock.flg">
                {{ item.lock.cause }}
            </a-descriptions-item>
            <a-descriptions-item label="锁定时间" v-if="item.lock.flg">
                {{ item.lock.time }}
            </a-descriptions-item>
            <a-descriptions-item label="解锁时间" v-if="item.lock.flg">
                {{ item.lock.resume }}
            </a-descriptions-item>
        </a-descriptions>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    methods: {
        execDownQr() {
            if (this.item.wxmp.qrst) {
                window.open('https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + this.item.wxmp.qrst)
            }
        }
    }
}
</script>
